import PropTypes from 'prop-types';
import React from 'react';
import ImageAttachment from './ImageAttachment';
import VideoAttachment from './VideoAttachment';
import PdfAttachment from './PdfAttachment';
import GenericAttachment from './GenericAttachment';
import FilePreview from './FilePreview';

const Attachment = ({ doc_type, ...props }) => {
  switch (doc_type) {
    case 'image':
      return <ImageAttachment {...props} />;
    case 'pdf':
      return <PdfAttachment {...props} />;
    case 'video':
      return <VideoAttachment {...props} />;
    case undefined:
      return props.file ? (
        <FilePreview
          blob={props.file.blob}
          preview={props.file.preview}
          mimeType={props.file.type}
        />
      ) : null;
    default:
      return <GenericAttachment {...props} />;
  }
};

Attachment.propTypes = {
  doc_type: PropTypes.oneOf(['generic', 'image', 'pdf', 'video']).isRequired,
  id: PropTypes.string,
  size: PropTypes.string,
  status: PropTypes.oneOf(['pending', 'success']),
  url: PropTypes.string,
};

Attachment.displayName = 'Attachment';

export default Attachment;
